export default __webpack_public_path__ + "static/media/3f85869c5f7cc1df9e42221fc237f594.svg";